import { useEffect, useRef } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Rrss from '../Rrss';
import { useStore } from '@/store/main';
import BotonFooter from '../Botones/Footer';
import HopName from '../Svgs/hopname';
import cn from 'classnames';
import styles from './index.module.scss';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { useRouter } from 'next/router';

gsap.registerPlugin(ScrollTrigger);

const Footer = (props) => {

  const footer = useRef(null);
  const { customer_services_info, customer_services_complain, follow_us, commerces, download, shipment } = props.footer
  const locale = props.locale

  const [footerNav1] = useStore((state) => [state.footerNav1]);
  const [footerNav2] = useStore((state) => [state.footerNav2]);
  const [footerNav3] = useStore((state) => [state.footerNav3]);

  useEffect(() => {
    gsap.context(() => {
      const tl = gsap
        .timeline({
          scrollTrigger: {
            trigger: '.footer-desktop-logo-js',
            start: 'top center+=20%',
            end: '+=30%',
            // markers: true,
            toggleActions: 'play none none reverse'
          }
        })
        .fromTo(
          '.footer-logo-h-js',
          {
            xPercent: -32,
            yPercent: -15,
            autoAlpha: 0
          },
          {
            yPercent: 0,
            xPercent: 0,
            autoAlpha: 1
          }
        )
        .fromTo(
          '.footer-logo-o-js',
          {
            autoAlpha: 0,
            xPercent: -32,
            yPercent: -15
          },
          {
            autoAlpha: 1,
            xPercent: 0,
            yPercent: 0,
            duration: 1.1
          },
          0.3
        )
        .fromTo(
          '.footer-logo-p-js',
          {
            autoAlpha: 0,
            xPercent: -65,
            yPercent: -25
          },
          {
            autoAlpha: 1,
            xPercent: 0,
            yPercent: 0,
            duration: 1.2
          },
          0.5
        );
    }, footer.current);

    setTimeout(() => {
      const handleScrollToSection = () => {
        const impacto = document.getElementById('impacto');
        if (impacto) {
          impacto.scrollIntoView({ behavior: 'smooth' });
        }
      };

      if (window.location.hash === '#impacto') {
        handleScrollToSection();
      }
    }, 1000);
  }, []);

  return (
    <footer
      ref={footer}
      className="site-max mx-auto relative w-full rounded-t-[3rem] sm:rounded-t-[5.2rem] pt-58 pb-50 bg-red"
    >
      <div className="site-grid">
        <div className="col-span-12 md:col-span-1 lg:col-span-4 sm:pt-43">
          <Link href={'/'} className="hidden sm:inline-block mb-60" locale={locale} aria-label="Ir a la página de inicio de HOP">
            {/* <HopName /> */}
            <div className="relative w-345 h-215 footer-desktop-logo-js">
              <div className="absolute top-[-24%] right-[17%] sm:top-[-2%] sm:right-[-1%] h-fit footer-logo-p-js">
                <Image
                  src="/images/conocenos/p.svg"
                  width={149}
                  height={193}
                  alt=""
                  className="w-40 sm:w-130 h-auto"
                />
              </div>
              <div className="absolute top-[-11%] left-[25%] sm:top-[11%] sm:left-[32%] h-fit footer-logo-o-js">
                <Image
                  src="/images/conocenos/o.svg"
                  width={181}
                  height={190}
                  alt=""
                  className="w-50 sm:w-150 h-auto"
                />
              </div>
              <div className="absolute bottom-0 h-fit footer-logo-h-js">
                <Image
                  src="/images/conocenos/h.svg"
                  width={174}
                  height={238}
                  alt=""
                  className="w-45 sm:w-[14.8rem] h-auto"
                />
              </div>
            </div>
          </Link>
          <Link href={'/'} className="inline-block sm:hidden w-345 mb-60" locale={locale} aria-label="Ir a la página de inicio de HOP">
            <HopName />
          </Link>
        </div>
        <div className="col-span-12 md:col-start-3 lg:col-start-5 lg:col-span-8">
          <div className="sm:ml-auto flex flex-col sm:flex-row items-start sm:items-center justify-center sm:justify-end mb-17">
            <div className="mb-32 sm:mb-0">
              <p className="p1 !text-10 text-white">{follow_us}</p>
            </div>
            <div className="flex items-center justify-between sm:justify-end w-full sm:w-fit">
              <div className="sm:ml-40">
                <Rrss
                  route="https://www.facebook.com/profile.php?id=100063532902489"
                  icon="/icons/facebook.svg"
                  ariaLabel="Visitar página de Facebook de HOP"
                />
              </div>
              <div className="sm:ml-40">
                <Rrss
                  route="https://www.linkedin.com/company/hop-envios/"
                  icon="/icons/linkedin.svg"
                  ariaLabel="Visitar página de LinkedIn de HOP"
                />
              </div>
              <div className="sm:ml-40">
                <Rrss
                  route="https://www.instagram.com/hopenvios/"
                  icon="/icons/instagram.svg"
                  ariaLabel="Visitar página de Instagram de HOP"
                />
              </div>
            </div>
          </div>
          <div className="w-full h-1 bg-white opacity-40 mb-40"></div>
          <div className="flex flex-wrap items-start justify-between">
            <div className="flex-shrink-0 w-1/2 sm:w-auto mb-50 sm:mb-0">
              <div className="mb-16">
                <p className="p1 !text-10 uppercase text-white">SOBRE HOP</p>
              </div>
              <nav>
                <ul>
                  {footerNav1.map((link, index) => {
                    return (
                      <li key={index} className={cn('mb-16 p2 text-white', styles.footerFirstNav)}>
                        <Link href={link.url} locale={locale} aria-label={`Ir a ${link.name}`}>{link.name}</Link>
                      </li>
                    );
                  })}
                  <li className={cn('mb-16 p2 text-white', styles.footerFirstNav)}>
                      <a href="https://clientes.hopenvios.net/" target="_blank" rel="noopener noreferrer" aria-label="Acceder al Portal Clientes">
                      Portal clientes
                      </a>
                    </li>
                    <li className={cn('mb-16 p2 text-white', styles.footerFirstNav)}>
                      <a href="https://hopsellersposventa.powerappsportals.com/" target="_blank" rel="noopener noreferrer" aria-label="Acceder al Portal Autogestión Casos">
                      Portal autogestión casos
                      </a>
                    </li>
                    <li className={cn('mb-16 p2 text-white', styles.footerFirstNav)}>
                      <a href="https://developers.hopenvios.net/" target="_blank" rel="noopener noreferrer" aria-label="Acceder a la documentación de desarrolladores de HOP">
                        Developers
                      </a>
                    </li>
                </ul>
              </nav>
            </div>
            <div className="flex-shrink-0 w-1/2 sm:w-auto">
              <div className="mb-16">
                <p className="p2 !text-10 uppercase text-white opacity-0 pointer-events-none select-none">
                  A
                </p>
              </div>
              <nav>
                <ul>
                  {footerNav2.map((link, index) => {
                    return (
                      <li key={index} className={cn('mb-16 p2 text-white', styles.footerFirstNav)}>
                        <Link href={link.url} locale={locale} aria-label={`Ir a ${link.name}`}>{link.name}</Link>
                      </li>
                    );
                  })}
                </ul>
              </nav>
            </div>
            <div className="flex-shrink-0 mb-50 sm:mb-0">
              <div className="mb-16">
                <p className="p2 !text-10 uppercase text-white">{ commerces }</p>
              </div>
              <nav>
                <ul>
                  {footerNav3.map((link, index) => {
                    return (
                      <li key={index} className={cn('mb-16 p2 text-white', styles.footerFirstNav)}>
                        <Link href={link.url} locale={locale} aria-label={`Ir a ${link.name}`}>{link.name}</Link>
                      </li>
                    );
                  })}
                </ul>
              </nav>
            </div>
            <div className="flex-shrink-0 w-full sm:w-auto mb-50 sm:mb-0">
              <div className="mb-16">
                <p className="p2 !text-10 uppercase text-white">USUARIOS</p>
              </div>
              {/* <div className="mb-16 sm:w-[16rem]">
                <BotonFooter label="Hacé tu envío" />
              </div> */}
              <div className="sm:w-[16rem]">
                <BotonFooter label={shipment} glass=" " route="/segui-tu-envio" />
              </div>
            </div>
            <div className="flex-shrink-0 w-full sm:w-auto mb-50 sm:mb-0">
              <div className="mb-16">
                <p className="p1 !text-10 uppercase text-white">{ download }</p>
              </div>
              <div className="flex sm:flex-col items-center justify-between">
                <div className="mb-16">
                  <Link
                    href={
                      'https://play.google.com/store/apps/details/HOP_Puntos_de_Entrega?id=com.hopenv'
                    }
                    target="_blank"
                    className="relative inline-block w-160 sm:w-120 group"
                    locale={locale}
                    aria-label="Descargar la aplicación HOP desde Google Play Store"
                  >
                    <Image
                      src="/images/google2.svg"
                      width={120}
                      height={35}
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </Link>
                </div>
                {/*<div className="mb-16">
                  <Link href={'/'} className="relative inline-block w-160 sm:w-120 group">
                    <Image
                      src="/images/app1.svg"
                      width={120}
                      height={34}
                      alt=""
                      className="w-full h-full object-cover"
                       locale={locale}
                    />
                  </Link>
                </div>*/}
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-12 flex flex-col sm:flex-row items-end justify-between">
          <div className="relative w-full sm:w-auto">
            <p className="inline-block p2 !text-13 text-white opacity-40 whitespace-nowrap cursor-default mb-16 sm:mb-0">
              HOP © {new Date().getFullYear()}. Todos los derechos reservados
            </p>
          </div>
          <div className="flex flex-wrap sm:flex-nowrap items-center justify-between mb-20 sm:mb-0">
            <Link
              href={customer_services_info}
              target="_blank"
              className={cn(
                'block p3 text-white opacity-40 sm:px-16 mb-16 sm:mb-0 whitespace-nowrap',
                styles.footerSecondNav
              )}
              locale={locale}
              aria-label="Ir a información de Defensa del consumidor"
            >
              Defensa del consumidor
            </Link>
            <Link
              href="/reclamo"
              className={cn(
                'block p3 text-white opacity-40 sm:px-16 mb-16 sm:mb-0 whitespace-nowrap',
                styles.footerSecondNav
              )}
              locale={locale}
              aria-label="Ir a formulario para iniciar un reclamo"
            >
              Iniciar un reclamo
            </Link>
            {/*<Link
              href={'/formar-parte'}
              className={cn(
                'block p3 text-white opacity-40 sm:px-16 mb-16 sm:mb-0 whitespace-nowrap',
                styles.footerSecondNav
              )}
              locale={locale}
            >
              Formar parte
            </Link>*/}
            <Link
              href={'/politicas-de-privacidad'}
              className={cn(
                'block p3 text-white opacity-40 sm:px-16 mb-16 sm:mb-0 whitespace-nowrap',
                styles.footerSecondNav
              )}
              locale={locale}
              aria-label="Ir a Políticas de privacidad"
            >
              Políticas de privacidad
            </Link>
            <Link
              href={'/terminos-y-condiciones'}
              className={cn(
                'block p3 text-white opacity-40 sm:px-16 mb-16 sm:mb-0 whitespace-nowrap',
                styles.footerSecondNav
              )}
              locale={locale}
              aria-label="Ir a Términos y Condiciones"
            >
              Términos y Condiciones
            </Link>
            <Link
              href={'/preguntas-frecuentes'}
              className={cn(
                'block p3 text-white opacity-40 sm:px-16 mb-16 sm:mb-0 whitespace-nowrap',
                styles.footerSecondNav
              )}
              locale={locale}
              aria-label="Ir a Preguntas frecuentes"
            >
              Preguntas frecuentes
            </Link>
          </div>
          <div className="flex items-end w-full sm:w-auto">
            <Link
              href={'https://estudionk.com/'}
              target="_blank"
              className={cn(
                'block p3 !text-13 text-white opacity-50 uppercase flex-shrink-0 mr-6 sm:mr-0',
                styles.footerSecondNav
              )}
              aria-label="Visitar sitio web de Estudio NK"
            >
              BY ESTUDIO/NK
            </Link>
            <div className="sm:hidden relative -top-5 sm:-top-15 w-full h-1 bg-white opacity-40"></div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
